/** Stock Reports — ageing, the plant × crop × variety × stage × year summary, and QC validity. */
import { reportPermissionsOf } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { ReportsPage } from "@/features/inventory/reports/reports-page";
import { useDeskFacility } from "@/features/warehouse/route-helpers";

const search = z.object({
  tab: z
    .enum(["ageing", "summary", "validity"])
    .default("ageing")
    .catch("ageing"),
  crop: z.number().int().positive().optional().catch(undefined),
  variety: z.number().int().positive().optional().catch(undefined),
  stage: z.string().optional().catch(undefined),
  year: z.string().optional().catch(undefined),
  bucket: z.string().optional().catch(undefined),
  within: z.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute("/_app/inventory/reports")({
  validateSearch: search,
  beforeLoad: () => {
    // Any Stock Report's own code opens the page (user, 2026-10-16).
    const { can } = useAuth.getState();
    if (!reportPermissionsOf("inventory").some((c) => can(c)))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReportsPage
      facilityId={useDeskFacility() ?? undefined}
      search={s}
      onSearch={(next) =>
        void navigate({
          search: (prev) => ({ ...prev, ...next }),
          replace: true,
        })
      }
    />
  );
}
